import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Modal from "../components/Modal";
import {
    getConfig, getCurrentBooking,
    getEndModalVisibility,
    getLoading, setActionAuthentication, setCurrentBooking,
    setEndModalVisibility, setError, setSuccess
} from "../reducers/configSlice";
import moment from "moment/moment";
import {apiAuthorizationToken, apiDeleteBooking, apiUpdateBooking} from "../api/actions";
import moment_tz from "moment-timezone";
import {CHECKIN_ACTION, DELETE_ACTION, END_ACTION} from "../constants/default";
import {addActionAuthenticationListener} from "../services/actionAuthentication/actionAuthenticationService";

const EndModal = () => {
    const dispatch = useDispatch()
    const currentBooking = useSelector(getCurrentBooking)
    const endModalVisible = useSelector(getEndModalVisibility)
    const config = useSelector(getConfig)

    const endBooking = async () => {
        if (!currentBooking) {
            return;
        }

        const bookingId = currentBooking.booking_id;
        const now = moment_tz.tz(moment().tz(config.timezone).format('YYYY-MM-DD HH:mm'), config.timezone).utc().tz(config.timezone)
        const minutesToSubtract = now.minute() % config.granularity

        const newEnd = now.subtract(minutesToSubtract, "minutes")
        const start = moment_tz.tz(currentBooking.start, config.timezone).utc().tz(config.timezone)

        dispatch(setEndModalVisibility(false))

        const hasCustomIntervals = config.intervals && config.intervals.custom;

        if (!hasCustomIntervals || (newEnd.diff(start, 'minutes') < config.granularity && !(currentBooking.other_dates && currentBooking.other_dates.length))) {
            if (config.require_login_actions) {
                const result = await apiAuthorizationToken(DELETE_ACTION, {booking_id: bookingId, terms_and_conditions: 1})

                if (result.status !== 1 || !result.code || !result.data) {
                    return;
                }

                const authAction = {
                    action: END_ACTION,
                    successMessage: translate("Booking successfully ended"),
                    link: result.data,
                    code: result.code
                };

                await addActionAuthenticationListener(authAction);
                dispatch(setActionAuthentication(authAction));

                return;
            }

            const { status, error } = await apiDeleteBooking(bookingId)

            if (error) {
                dispatch(setError(error))

                return;
            }

            if (status !== 1) {
                return;
            }

            dispatch(setSuccess(translate("Booking successfully ended")))
            dispatch(setCurrentBooking(null))

            return;
        }

        let data = {}

        data.terms_and_conditions = 1
        data.dates = [
            {
                start: currentBooking.start,
                end: newEnd.format('YYYY-MM-DD HH:mm')
            }
        ]

        if (currentBooking.other_dates && currentBooking.other_dates.length) {
            currentBooking.other_dates.forEach( (date, index) => {
                data.dates.push({
                    start: date.start,
                    end: date.end
                })
            })
        }

        if (config.require_login_actions) {
            data.booking_id = bookingId
            const result = await apiAuthorizationToken(END_ACTION, data)

            if (result.status !== 1 || !result.code || !result.data) {
                return;
            }

            const authAction = {
                action: END_ACTION,
                successMessage: translate("Booking successfully ended"),
                link: result.data,
                code: result.code
            }

            await addActionAuthenticationListener(authAction)
            dispatch(setActionAuthentication(authAction))

            return;
        }

        const { status, error } = await apiUpdateBooking(bookingId, data)

        if (error) {
            dispatch(setError(error))

            return;
        }

        if (status !== 1) {
            return;
        }

        dispatch(setSuccess(translate("Booking successfully ended")))
        dispatch(setCurrentBooking(null))
    }

    return (
        <Modal visible={endModalVisible}
               onClose={() => {dispatch(setEndModalVisibility(false))}}
               icon={require('../../assets/images/end-icon.png')}
               title={translate("End the current booking?")}
               subtitle={translate("If you end it, the room will become available right away")}
               disabled={false}
               buttonText={translate("Yes, end booking").toUpperCase()}
               onButtonPress={endBooking}
               merged={true}
        >
        </Modal>
    )
}

export default EndModal
